import domain from '@/util/domain'
const urlImages = `https://dozr8la71aog.cloudfront.net/domains/${domain()}/img/exceptional`

const peculiar = [
  {
    label: "A. do Sul",
    src: `${urlImages}/americadosul.png`,
    href: "/countries/6046/?sport=Futebol&category=América do Sul#scrollTop",
  },
  {
    label: "Europa",
    src: `${urlImages}/europa.png`,
    href: "/countries/6046/?sport=Futebol&category=Europa#scrollTop",
  },
  {
    label: "Asia",
    src: `${urlImages}/asia.png`,
    href: "/countries/6046/?sport=Futebol&category=Asia#scrollTop",
  },
  {
    label: "Oceania",
    src: `${urlImages}/oceania.png`,
    href: "/countries/6046/?sport=Futebol&category=Oceania#scrollTop",
  },
  {
    label: "Africa",
    src: `${urlImages}/africa.png`,
    href: "/countries/6046/?sport=Futebol&category=Africa#scrollTop",
  },
  {
    label: "Europa 2",
    src: `${urlImages}/europa2.png`,
    href: "/countries/6046/?sport=Futebol&category=Europa 2#scrollTop",
  },
  {
    label: "Europa 3",
    src: `${urlImages}/europa3.png`,
    href: "/countries/6046/?sport=Futebol&category=Europa 3#scrollTop",
  },
  {
    label: "A. do Sul 2",
    src: `${urlImages}/americadosul2.png`,
    href: "/countries/6046/?sport=Futebol&category=América do Sul2#scrollTop",
  },
  {
    label: "Ori. Médio",
    src: `${urlImages}/orientemedio.png`,
    href: "/countries/6046/?sport=Futebol&category=Oriente Médio#scrollTop",
  },
]

export default peculiar